import Loadable from '../../components/loadable';

const TasksListFiltersModal = Loadable({
  loader: () => import('../../pages/tasks/tasks_list_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('TasksListFiltersModal', TasksListFiltersModal);
